import { CssBaseline, ThemeProvider } from '@mui/material';
import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import RTL from 'components/RTL';
import { PromptProvider } from 'contexts/promptContext';
import useSettings from 'hooks/useSettings';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './i18n';
import routes from './routes';
import { createCustomTheme } from './theme';

const App = () => {
  const router = createBrowserRouter(routes());
  const { settings } = useSettings();
  const theme = createCustomTheme({
    theme: settings.theme,
  });
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <RTL>
          <PromptProvider>
            <CssBaseline />
            <RouterProvider router={router} />
          </PromptProvider>
        </RTL>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
